<template>
  <div>
    <h2 class="step-name"> Deer Disease </h2>
    <discussion-points title='Discussion'
                       comments-field="deer_disease_discussion"
                       points="Yersinia, Johnes, Lepto, Fusobacteriosis, MCF, Parapox, TB, Ryegrass staggers, Misadventure">
    </discussion-points>
    <div class="step-section">
      <h3>Deer Vaccine Purchases</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Purchase Date</th>
            <th>Animal Name</th>
            <th>Stock Code - Name</th>
            <th>Quantity</th>
            <th>Doses</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in getChartData('deer_vax_purchases')" :key="index">
            <td class="text-left">{{ row["Purchase Date"] }}</td>
            <td class="text-left">{{ row["Animal Name"] }}</td>
            <td class="text-left">{{ row["Stock Code - Name"] }}</td>
            <td class="text-left">{{ row["Quantity"] }}</td>
            <td class="text-left">{{ row["Doses"] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="step-section">
      <div class="form-group">
        <span class="form-group">
          <label>Yersinia</label>
          <comments field-name="yersinia_comments">
          </comments>
        </span>
      </div>
      <div class="form-group">
        <span class="form-group">
          <label>Lepto</label>
          <comments field-name="lepto_comments">
          </comments>
        </span>
      </div>
      <div class="form-group">
        <span class="form-group">
          <label>Johnes</label>
          <comments field-name="johnes_comments">
          </comments>
        </span>
      </div>
    </div>

    <drug-allocation-cart :drugGroups="getFieldValue('DRUG_GROUPS')"
                          animalType='deer'>
    </drug-allocation-cart>

  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'
import DrugAllocationCart from './DrugAllocationCart'


export default {
  name: 'DeerDisease',
  mixins: [ baseComponent ],
  components: {
    DrugAllocationCart,
  },
};
</script>

